import { render, staticRenderFns } from "./UserTagSelect.vue?vue&type=template&id=08f9cb2e&"
import script from "./UserTagSelect.vue?vue&type=script&lang=ts&"
export * from "./UserTagSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports